import { render, staticRenderFns } from "./Auction.vue?vue&type=template&id=520f25f2&scoped=true&"
import script from "./Auction.vue?vue&type=script&lang=js&"
export * from "./Auction.vue?vue&type=script&lang=js&"
import style0 from "./Auction.vue?vue&type=style&index=0&id=520f25f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f25f2",
  null
  
)

export default component.exports